function normalizeUrl(value: string | undefined): string {
  return (value || '').trim().replace(/\/+$/, '');
}

function parseNumber(value: string | undefined, fallback: number): number {
  const parsed = Number(value);
  return Number.isFinite(parsed) && parsed > 0 ? parsed : fallback;
}

const runtimeEnv = import.meta.env ?? {};
const DEFAULT_PROXY_TIMEOUT_MS = 30000;

export const RENDERER_RUNTIME_CONFIG = {
  appVersion: (runtimeEnv.VITE_APP_VERSION || '').trim(),
  krNudgeUrl: normalizeUrl(runtimeEnv.VITE_KR_NUDGE_URL),
  aiProxyUrl: normalizeUrl(runtimeEnv.VITE_AI_PROXY_URL),
  assistantChatUrl: normalizeUrl(runtimeEnv.VITE_ASSISTANT_CHAT_URL),
  translateProxyUrl: normalizeUrl(runtimeEnv.VITE_TRANSLATE_PROXY_URL),
  authRequestUrl: normalizeUrl(runtimeEnv.VITE_AUTH_REQUEST_URL),
  authExchangeUrl: normalizeUrl(runtimeEnv.VITE_AUTH_EXCHANGE_URL),
  authSsoLookupUrl: normalizeUrl(runtimeEnv.VITE_AUTH_SSO_LOOKUP_URL),
  authSsoCreateUrl: normalizeUrl(runtimeEnv.VITE_AUTH_SSO_CREATE_URL),
  authSsoExchangeUrl: normalizeUrl(runtimeEnv.VITE_AUTH_SSO_EXCHANGE_URL),
  analyticsProxyUrl: normalizeUrl(runtimeEnv.VITE_ANALYTICS_PROXY_URL),
  developmentApiUrl: normalizeUrl(runtimeEnv.VITE_DEVELOPMENT_API_URL),
  developmentApiKey: (runtimeEnv.VITE_DEVELOPMENT_API_KEY || '').trim(),
  proxyTimeoutMs: parseNumber(runtimeEnv.VITE_PROXY_TIMEOUT_MS, DEFAULT_PROXY_TIMEOUT_MS),
} as const;
